import { customElement, property } from 'lit/decorators.js';
import { pillStyle } from './Pill.styles';
import { ButtonBase } from '../button/Button.component';

export type PillVariant = 'on-dark' | 'on-dark-transparent' | 'on-light' | 'on-light-transparent';

@customElement('lr-pill')
export class Pill extends ButtonBase {
    @property({ type: String, reflect: true })
    variant: PillVariant = 'on-light';

    static styles = [ButtonBase.styles, pillStyle];
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-pill': Pill;
    }
}
